export const CLASSNAMES = {
  ACTIVE: 'btn btn-info',
  SECONDARY: 'btn btn-outline-secondary',
};
